import { NavLink, useLocation } from "react-router-dom";
import { topicNavigation } from "../config/siteNavigation";
import "../style/articleLayout.css";

export default function TopicSidebar({ toc = [], ctas = {}, next, previous, topicGroups = topicNavigation }) {
  const location = useLocation();

  const scrollToSection = (href) => {
    if (!href?.startsWith("#")) {
      return;
    }

    const target = document.getElementById(href.slice(1));

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <aside className="topic-sidebar">
      {toc.length > 0 && (
        <div className="topic-sidebar-card toc-sidebar-card">
          <span className="topic-sidebar-eyebrow">On this page</span>
          <nav aria-label="Article table of contents">
            {toc.map((item) => (
              <button type="button" onClick={() => scrollToSection(item.href)} key={item.label}>
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      )}

      <div className="topic-sidebar-card topic-cta-card">
        <span className="topic-sidebar-eyebrow">Next action</span>
        <NavLink to={ctas.practice?.to || "/automation-testing"} className="topic-cta primary">
          {ctas.practice?.label || "Practice Now"}
        </NavLink>
        <NavLink to={ctas.notes?.to || "/study-notes"} className="topic-cta secondary">
          {ctas.notes?.label || "Download Notes"}
        </NavLink>
        <NavLink to={ctas.course?.to || "/enroll"} className="topic-cta dark">
          {ctas.course?.label || "Join Course"}
        </NavLink>
      </div>

      {(previous || next) && (
        <div className="topic-sidebar-card topic-nav-card">
          <span className="topic-sidebar-eyebrow">Topic flow</span>
          {previous && (
            <NavLink to={previous.to}>
              <small>Previous</small>
              <strong>{previous.label}</strong>
            </NavLink>
          )}
          {next && (
            <NavLink to={next.to}>
              <small>Next</small>
              <strong>{next.label}</strong>
            </NavLink>
          )}
        </div>
      )}

      {topicGroups.length > 0 && (
        <div className="topic-sidebar-card all-topics-card">
          <span className="topic-sidebar-eyebrow">All topics</span>
          <div className="topic-group-list">
            {topicGroups.map((group) => (
              <details
                className="topic-group"
                key={`${group.group}-${location.pathname}`}
                defaultOpen={group.items.some((item) => item.to === location.pathname)}
              >
                <summary>{group.group}</summary>
                <nav aria-label={`${group.group} topic navigation`}>
                  {group.items.map((item) => (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      className={({ isActive }) => (isActive ? "active-topic-link" : undefined)}
                    >
                      {item.label}
                    </NavLink>
                  ))}
                </nav>
              </details>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
}
